import startCase from 'lodash/startCase';
import { Design } from '@/types';

export default function ComplexityLabel({ design }: { design: Design }) {
  if (design.decoration_type?.unit) {
    return <span># {startCase(design.decoration_type.unit)}</span>;
  }
  return <span>Complexity</span>;
}
